import { useEffect } from 'react';

import { getConfig } from '@/lib/config';
import { resetMixpanel } from '@/lib/mixpanel';
import { useAuth0 } from '@auth0/auth0-react';

export default function LogoutPage() {
  const { logout } = useAuth0();
  const config = getConfig();

  useEffect(() => {
    resetMixpanel();
    logout({ logoutParams: { returnTo: config.auth0.logoutUri } });
  }, [logout, config.auth0.logoutUri]);

  return null;
}
